import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons'

export default function PageReport({ data }) {
  return (
    <div>
      <h2 className='text-xl mb-4 font-bold text-slate-700 lg:mb-5 lg:text-3xl'>
        <FontAwesomeIcon icon={faSquareCheck} className='mt-0.5 mr-3 text-blue-400' />
        시험 성적서
      </h2>

      <div className='flex flex-col gap-10 text-center text-gray-700 lg:flex-row lg:gap-12'>
        {data.map((item, index) => (
          <div className='inset-content-box w-full p-8 rounded-xl lg:w-1/2 lg:p-12' key={index}>
            <span className='text-lg font-bold lg:text-xl'>{item.title}</span>
            <ul className='mt-6 mb-7 ml-1 text-base text-left lg:mt-8 lg:mb-9'>
              {item.content.map((content, index) => (
                <li className='text-sm leading-10' key={index}>
                  {content}
                </li>
              ))}
            </ul>
            {item.image?.map((image, index) => (
              <img src={image} key={index} />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
